import trim from 'lodash/trim';
import type { BusinessPersistenceModel } from '../../data-layer/business/types';
import type { BusinessPersistenceUI } from '../../ui/business/types';

export const toBusinessPersistenceModel = (
    model: BusinessPersistenceUI,
): BusinessPersistenceModel => ({
    id: model.id,
    publicId: model.publicId,
    displayName: model.displayName,
    description: trim(model.description),
    descriptionStatus: model.descriptionStatus,
    avatarUrl: model.avatarUrl,
    coverUrl: model.coverUrl,
    links: model.links,
    createdAt: model.createdAt,
    hideInFeed: model.hideInFeed ?? false,
    offerAgreement: model.offerAgreement,
    instagram: model.instagram,
    telegram: model.telegram,
    ads: model.ads,
    categories: model.categories,
    useProductsAutoImport: model.useProductsAutoImport,
    useProductsDisableAutoParser: model.useProductsDisableAutoParser,
    allowedToBoosts: model.allowedToBoosts,
    geotargeting: model.geotargeting,
});

export const toBusinessGeoModel = (regions: Record<string, string>) =>
    Object.keys(regions).map((id) => Number(id));
